import { Login } from "@mui/icons-material";
import { List } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import NaviItem from "../atoms/NaviItem";


const NonAuthNavi: React.FC = () => {
    let navigate = useNavigate();

    return (
        <List component="nav">
            <NaviItem
                icon={<Login />}
                onClick={() => {
                    navigate("/login")
                }}
                text="サインイン"
            />
        </List>
    );
}

export default NonAuthNavi